import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { Album } from './usePaginateAlbums'

const fetchAlbumById = async (id: string): Promise<Album> => {
  const { data } = await api.get<Album>(`/albums/${id}`)
  return data
}

export const useGetAlbumById = (id: string) => {
  return useQuery<Album>({
    queryKey: ['album', id],
    queryFn: () => fetchAlbumById(id),
    enabled: !!id,
  })
}
